export interface activateUser{
    activationGuid:string,
    password:string
}

export function defaultActivationValues():activateUser{
    return {activationGuid:"",password:""}
}

